import { useState } from 'react';
import { SheetB } from '../SheetB';

/**
 * B spec §2.4 setup section 1 — **the create-opponent sheet** (build unit B-7, PRE-1): name
 * required (`ERR_TEAM_NAME_REQUIRED` is the engine truth behind the disabled control), club and
 * age group optional. Same shape as B-6's `PlayerSheet`: full-screen `SheetB`, primary action
 * in the sticky top header where the keyboard cannot cover it, every field ≥16 px computed.
 */

export interface NewOpponentSheetProps {
  readonly busy: boolean;
  readonly onCreate: (name: string, club: string, ageGroup: string) => void;
  readonly onClose: () => void;
}

export function NewOpponentSheet({ busy, onCreate, onClose }: NewOpponentSheetProps) {
  const [name, setName] = useState('');
  const [club, setClub] = useState('');
  const [ageGroup, setAgeGroup] = useState('');

  return (
    <SheetB
      titleId="setup-opponent-title"
      title="New opponent"
      testId="setup-opponent-sheet"
      onClose={onClose}
      actions={
        <>
          <button
            type="button"
            className="sheet-b__primary"
            data-testid="setup-team-save"
            disabled={name.trim() === '' || busy}
            onClick={() => {
              onCreate(name, club, ageGroup);
            }}
          >
            Add opponent
          </button>
          <button
            type="button"
            className="sheet-b__secondary"
            data-testid="setup-team-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </>
      }
    >
      <label className="sheet-b__label" htmlFor="setup-team-name">
        Team name
      </label>
      <input
        id="setup-team-name"
        className="sheet-b__field"
        data-testid="setup-team-name"
        type="text"
        autoComplete="off"
        placeholder="Riverside Colts"
        value={name}
        onChange={(event) => {
          setName(event.target.value);
        }}
      />

      <label className="sheet-b__label" htmlFor="setup-team-club">
        Club (optional)
      </label>
      <input
        id="setup-team-club"
        className="sheet-b__field"
        data-testid="setup-team-club"
        type="text"
        autoComplete="off"
        value={club}
        onChange={(event) => {
          setClub(event.target.value);
        }}
      />

      <label className="sheet-b__label" htmlFor="setup-team-age">
        Age group (optional)
      </label>
      <input
        id="setup-team-age"
        className="sheet-b__field"
        data-testid="setup-team-age"
        type="text"
        autoComplete="off"
        placeholder="U12"
        value={ageGroup}
        onChange={(event) => {
          setAgeGroup(event.target.value);
        }}
      />
    </SheetB>
  );
}
